import React from 'react';
import { useTranslation } from 'react-i18next';
import { HistoryControlsView } from '../../../components/card-controls/history-controls/history-controls-view';
import {
  useCanRedo,
  useCanUndo,
  useEditHistoryCoordinator,
  useIsRestoring,
  useLastRestoreError,
} from '../edit-history-store';

export const HistoryControlsAdapter = (): React.ReactElement | null => {
  const coordinator = useEditHistoryCoordinator();
  const canUndo = useCanUndo();
  const canRedo = useCanRedo();
  const isRestoring = useIsRestoring();
  const lastRestoreError = useLastRestoreError();
  const { t } = useTranslation();

  if (!coordinator) {
    return null;
  }

  return (
    <HistoryControlsView
      canUndo={canUndo}
      canRedo={canRedo}
      isRestoring={isRestoring}
      lastRestoreError={lastRestoreError}
      groupLabel={String(t('cardEditor.historyControls'))}
      undoLabel={String(t('cardEditor.undo'))}
      redoLabel={String(t('cardEditor.redo'))}
      restoreFailedLabel={String(t('cardEditor.historyRestoreFailed'))}
      onUndo={() => void coordinator.undo()}
      onRedo={() => void coordinator.redo()}
    />
  );
};
